import { useCallback, useReducer } from "react";
import { matchPath } from "react-router";

import { propUpdateReducer } from "components/Core/propUpdateReducer";

import { MODULE_CALCULATORS, MODULE_FARM_VAULT, MODULE_FINANCIAL, MODULE_MARKETING } from "../config/constants";

/**
 * Hook for managing module navigation state and module-related calculations
 */
export const useModuleNavigation = (navigate, pathname) => {
  const [subMenuOpenState, dispatchSubMenuOpenState] = useReducer(propUpdateReducer, {});

  const calculateIsModuleActive = useCallback(
    (_module) => {
      return calculateIsModuleActive_Intern(_module, pathname);
    },
    [pathname]
  );

  const calculateIsModuleActive_Intern = useCallback((_module, _pathname) => {
    if (_pathname) {
      return Boolean(matchPath(`/${_module}/*`, _pathname));
    }
    return false;
  }, []);

  const calculateIsSubMenuOpen = useCallback(
    (key) => {
      if (subMenuOpenState[key] === false) {
        return false;
      }
      return calculateIsModuleActive(key) || subMenuOpenState[key];
    },
    [calculateIsModuleActive, subMenuOpenState]
  );

  const setIsSubMenuOpen = useCallback((key, isOpen) => {
    dispatchSubMenuOpenState({
      type: "update",
      payload: {
        key: key,
        value: isOpen,
      },
    });

    if (isOpen && key !== MODULE_FARM_VAULT) {
      dispatchSubMenuOpenState({
        type: "update",
        payload: {
          key: MODULE_FARM_VAULT,
          value: false,
        },
      });
    }
  }, []);

  const toggleIsSubMenuOpen = useCallback(
    (key) => {
      const isOpen = calculateIsSubMenuOpen(key);

      dispatchSubMenuOpenState({
        type: "update",
        payload: {
          key: key,
          value: !isOpen,
        },
      });
    },
    [calculateIsSubMenuOpen]
  );

  const handleNavigate = useCallback(
    async (path) => {
      navigate(path);

      if (!calculateIsModuleActive_Intern(MODULE_FARM_VAULT, path)) {
        setIsSubMenuOpen(MODULE_FARM_VAULT, false);
      }
      if (!calculateIsModuleActive_Intern(MODULE_FINANCIAL, path)) {
        setIsSubMenuOpen(MODULE_FINANCIAL, false);
      }
      if (!calculateIsModuleActive_Intern(MODULE_CALCULATORS, path)) {
        setIsSubMenuOpen(MODULE_CALCULATORS, false);
      }
      if (!calculateIsModuleActive_Intern(MODULE_MARKETING, path)) {
        setIsSubMenuOpen(MODULE_MARKETING, false);
      }
    },
    [navigate, calculateIsModuleActive_Intern, setIsSubMenuOpen]
  );

  return {
    calculateIsModuleActive,
    calculateIsSubMenuOpen,
    toggleIsSubMenuOpen,
    handleNavigate,
  };
};
